<template>
  <svg width="124" height="162" viewBox="0 0 124 162" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M101 146L74.3661 9.77082C73.2564 4.09519 68.2831 0 62.5 0C56.7169 0 51.7435 4.0952 50.6339 9.77083L24 146H101Z" fill="url(#paint0_linear_14609_312942)" />
    <path d="M124 162H0L2.52995 142H121.893L124 162Z" fill="url(#paint1_linear_14609_312942)" />
    <path d="M90.8418 94H34.1675L42.7686 50H82.2563L90.8418 94Z" fill="url(#paint2_linear_14609_312942)" />
    <defs>
      <linearGradient id="paint0_linear_14609_312942" x1="89.4359" y1="78.4401" x2="-31.0656" y2="51.0155" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFAB34" />
        <stop offset="1" stop-color="#FFE2B9" />
      </linearGradient>
      <linearGradient id="paint1_linear_14609_312942" x1="81.8868" y1="150.421" x2="64.1637" y2="107.849" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFA320" />
        <stop offset="1" stop-color="#FFE2B9" />
      </linearGradient>
      <linearGradient id="paint2_linear_14609_312942" x1="82.4393" y1="73.6395" x2="10.9559" y2="33.6784" gradientUnits="userSpaceOnUse">
        <stop stop-color="#ECECEC" />
        <stop offset="1" stop-color="white" stop-opacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
</template>
